import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[maxlength]'
})
export class MaxLengthDirective {
  @Input('maxlength') maxLengthValue: number;
  private inputElement: HTMLInputElement;

  constructor(private el: ElementRef) {
    this.inputElement = this.el.nativeElement;
  }

  @HostListener('input', ['$event'])
  onInput(event: Event) {
    const initalValue = this.inputElement?.value;
    if (initalValue?.length > this.maxLengthValue) {
      this.inputElement.value = initalValue.substring(0, this.maxLengthValue);
      event.stopPropagation();
    }
  }
}
